/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 19:00:02
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'

export default {

  
   /**
   * getChannelList
   * @description 商户管理-渠道列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getChannelList(data) {
    return request.get(`${BASE_URL}/channel/list`, data)
  },

  /**
   * createChannel
   * @description 商户管理-渠道新增
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createChannel(data) {
    return request.post(`${BASE_URL}/channel/store`, data)
  },

  /**
   * channelView
   * @description 商户管理-渠道详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  channelView(data) {
    return request.get(`${BASE_URL}/channel/view/${data}`)
  },

  /**
   * updateChannel
   * @description 商户管理-渠道编辑
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  updateChannel(id, data) {
    return request.put(`${BASE_URL}/channel/update/${id}`, data)
  },

  /**
   * deleteChannel
   * @description 商户管理-渠道删除
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  deleteChannel(data) {
    return request.Delete(`${BASE_URL}/channel/delete/${data}`)
  },

  /**
   * channelAudit
   * @description 商户管理-渠道状态审核
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  channelAudit(id, data) {
    return request.put(`${BASE_URL}/channel/audit/${id}`, data)
  },

  /**
   * channelAudit
   * @description 用户列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  channelUserList(data) {
    return request.get(`${BASE_URL}/channel/user_list`, data)
  },

  /**
   * channelAudit
   * @description 用户新增
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  channelSaveUser(data) {
    return request.post(`${BASE_URL}/channel/save_user`, data)
  },

  /**
   * channelAudit
   * @description 用户编辑
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  channelUpdateUser(id, data) {
    return request.put(`${BASE_URL}/channel/update_user/${id}`, data)
  },

  /**
   * channelAudit
   * @description 用户移除
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  channelMoveUser(id, data) {
    return request.put(`${BASE_URL}/channel/move_user/${id}`, data)
  }
}